import React, { useState } from 'react';
import { Dropdown, DropdownList, DropdownItem } from '@cokitchen/cokitchen-components';
import { ArrowDownIcon, UserIcon } from 'cokitchen-icons';
import { STORAGE_KEYS } from 'utils/constants';
import useRoleContext from 'contexts/role.context';
import { useNavigate } from 'react-router-dom';
const UserDropdown = () => {
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);
  const firstName = localStorage.getItem(STORAGE_KEYS.FIRST_NAME) ?? 'Inventory';
  const lastName = localStorage.getItem(STORAGE_KEYS.LAST_NAME) ?? 'Rep';
  const email = localStorage.getItem(STORAGE_KEYS.EMAIL) ?? 'Rep';
  const { role } = useRoleContext();

  const handleDropdownToggle = () => {
    setShowDropdown(!showDropdown);
  };

  const goToProfile = () => {
    navigate('/profile');
  };
  return (
    <Dropdown
      visible={showDropdown}
      onClickOutside={() => setShowDropdown(false)}
      className=''
      content={
        <div
          onClick={handleDropdownToggle}
          className='flex items-center gap-1 sm:gap-4 flex-wrap cursor-pointer'>
          <div className='flex items-center gap-2 sm:gap-4'>
            <div className='flex items-center justify-center w-12 h-12 p-[10px] rounded-full text-white text-lg bg-red-5'>
              {firstName[0]}
              {lastName[0]}
            </div>
            <div className='flex-col hidden md:flex '>
              <p className='text-gray-10'>{email}</p>
              <p className='font-normal text-xs text-gray-9'>{role?.name}</p>
            </div>
          </div>
          <ArrowDownIcon className={`ml-5 text-gray-8 ${showDropdown ? 'rotate-180' : ''}`} />
        </div>
      }>
      <DropdownList className='max-h-fit w-full list'>
        <DropdownItem onClick={goToProfile}>
          <div className='flex gap-3 items-center'>
            <UserIcon className='text-[#96999C] w-[18px] h-[18px]' />
            <p className='text-[#5E6164] text-sm font-medium'>Profile</p>
          </div>
        </DropdownItem>
      </DropdownList>
    </Dropdown>
  );
};

export default UserDropdown;
